import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findProjectDraw = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-percentage?` + params,
        method: 'GET'
    })
}
export const findEngineeringDynamicId = (id) => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-percentage/${id}`,
        method: 'GET'
    })
}

export const findEngineeringProjectAll = () => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-project/all`,
        method: 'GET'
    })
}

export const addEngineeringPercentage = (params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-percentage`,
        method: 'POST',
        data: params
    })
}
export const findAllSuperiorDepartment = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/findAllSuperiorDepartment`,
        method: 'GET'
    })
}
export const findEngineeringPercentageDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-percentage/${id}`,
        method: 'GET'
    })
}

export const editEngineeringPercentage = (params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-percentage`,
        method: 'PUT',
        data: params
    })
}

export const findPercentage = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/percentage?` + params,
        method: 'GET'
    })
}
export const findProject = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/project/select?` + params,
        method: 'GET'
    })
}

export const findProvince = () => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province`,
        method: 'GET'
    })
}
export const findCitys = (id) => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province/citys/${id}`,
        method: 'GET'
    })
}
export const findAreas = (id) => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province/areas/${id}`,
        method: 'GET'
    })
}
/**
 * 控件类型列表
 */
export const findDataSourceFields = () => {
    return request({
        url: `${baseUrl}/joins-work/v1/dataSource/fields`,
        method: 'GET'
    })
}
/**
 * 数据源
 */
export const findDataSourceAll = () => {
    return request({
        url: `${baseUrl}/joins-work/v1/dataSource`,
        method: 'GET'
    })
}

export const addPercentage = (params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/percentage`,
        method: 'POST',
        data: params
    })
}

export const delItem = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-percentage/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}







export const findTagslList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/label?` + params,
        method: 'GET'
    })
}

export const findLabelList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/label/select?` + params,
        method: 'GET'
    })
}


export const delTags = (ids) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/label/${ids}`,
        method: 'DELETE',
    })
}